import React from 'react'
import withParams from '../../../modules/router-manage/withParams'
import ContributorFormContainer from '../../templates/contributor-form/ContributorFormContainer'
import Navbar from '../../templates/navbar/Navbar';

function ContributorFormPage({ params }) {
  return (
    <div>
      <Navbar />
      <div className="container">
        <div className="section">
          {/* <ContributorListHeader /> */}
          <ContributorFormContainer params={params} />
        </div>
      </div>
    </div>
  )
}

export default withParams(ContributorFormPage)



// WEBPACK FOOTER //
// ./src/components/pages/web/ContributorFormPage.js